var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcTif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C13.3687 0 11.625 1.74375 11.625 3.875V58.125C11.625 60.2562 13.3687 62 15.5 62H54.25C56.3812 62 58.125 60.2562 58.125 58.125V15.5L42.625 0H15.5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 15.5H58.125L42.625 0V11.625C42.625 13.7563 44.3687 15.5 46.5 15.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.125 27.125L46.5 15.5H58.125V27.125Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.375 50.375C50.375 51.4406 49.5031 52.3125 48.4375 52.3125H5.8125C4.74687 52.3125 3.875 51.4406 3.875 50.375V31C3.875 29.9344 4.74687 29.0625 5.8125 29.0625H48.4375C49.5031 29.0625 50.375 29.9344 50.375 31V50.375Z",
    fill: "#A647BE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4375 52.3125H11.625V54.25H48.4375C49.5031 54.25 50.375 53.3781 50.375 52.3125V50.375C50.375 51.4406 49.5031 52.3125 48.4375 52.3125Z",
    fill: "#CAD1D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.648 46.075C20.348 46.075 20.108 45.99 19.928 45.82C19.758 45.64 19.673 45.405 19.673 45.115V37.015H16.943C16.343 37.015 16.043 36.75 16.043 36.22C16.043 35.69 16.343 35.425 16.943 35.425H24.338C24.938 35.425 25.238 35.69 25.238 36.22C25.238 36.75 24.938 37.015 24.338 37.015H21.608V45.115C21.608 45.405 21.518 45.64 21.338 45.82C21.168 45.99 20.938 46.075 20.648 46.075ZM27.3422 46.09C27.0522 46.09 26.8172 46 26.6372 45.82C26.4672 45.64 26.3822 45.405 26.3822 45.115V36.31C26.3822 36.02 26.4672 35.79 26.6372 35.62C26.8172 35.44 27.0522 35.35 27.3422 35.35C27.6422 35.35 27.8772 35.44 28.0472 35.62C28.2272 35.79 28.3172 36.02 28.3172 36.31V45.115C28.3172 45.405 28.2272 45.64 28.0472 45.82C27.8772 46 27.6422 46.09 27.3422 46.09ZM31.5609 46.09C31.2709 46.09 31.0359 46 30.8559 45.82C30.6859 45.64 30.6009 45.405 30.6009 45.115V36.34C30.6009 36.05 30.6809 35.825 30.8409 35.665C31.0109 35.505 31.2409 35.425 31.5309 35.425H36.7959C37.4059 35.425 37.7109 35.685 37.7109 36.205C37.7109 36.715 37.4059 36.97 36.7959 36.97H32.5059V39.85H36.4959C37.1059 39.85 37.4109 40.11 37.4109 40.63C37.4109 41.14 37.1059 41.395 36.4959 41.395H32.5059V45.115C32.5059 45.405 32.4209 45.64 32.2509 45.82C32.0809 46 31.8509 46.09 31.5609 46.09Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTif);
export default __webpack_public_path__ + "static/media/ic_tif.2e75f9559bd23f1b5e0d2b199f6a49cd.svg";
export { ForwardRef as ReactComponent };